export const membersData = {
    data() {
        return {
            membersList: [
                {
                    id: 1,
                    order: 1,
                    name: "امین سنجرموسوی",
                    side: "مدیریت",
                    expertise: "کارشناسی مدیریت",
                    phone: ["0513892xxxx", "0915515xxxx", "093047xxxx"],
                    phoneActive: true,
                    chatActive: true,
                    email: "amin.sanjar@gmail.com",
                    avatar: "https://mdbcdn.b-cdn.net/img/new/avatars/1.jpg",
                    active: true
                },
                {
                    id: 2,
                    order: 2,
                    name: "محمد کریمی",
                    side: "بازرگانی",
                    expertise: "مهندسی مکانیک",
                    phone: ["0513892xxxx", "0915515xxxx", "093047xxxx"],
                    phoneActive: false,
                    chatActive: true,
                    email: "moosavi1268@gmail.com",
                    avatar: "https://mdbcdn.b-cdn.net/img/new/avatars/2.jpg",
                    active: true
                },
                {
                    id: 3,
                    order: 3,
                    name: "حمید رضایی",
                    side: "چندرسانه ای",
                    expertise: "کارگردانی",
                    phone: ["0513892xxxx", "0915515xxxx", "093047xxxx"],
                    phoneActive: true,
                    chatActive: false,
                    email: "modiri2455@gmail.com",
                    avatar: "https://mdbcdn.b-cdn.net/img/new/avatars/3.jpg",
                    active: true
                },
                {
                    id: 4,
                    order: 4,
                    name: "نرگس محمدی",
                    side: "عکاس",
                    expertise: "هنر های تصویری",
                    phone: ["0513892xxxx", "0915515xxxx", "093047xxxx"],
                    phoneActive: false,
                    chatActive: false,
                    email: "modiri2455@gmail.com",
                    avatar: "https://mdbcdn.b-cdn.net/img/new/avatars/6.jpg",
                    active: true
                }
            ]
        }
    },
    methods: {
        getSummary() {
            return this.membersList.slice(0, 4);
        },
    }

}